import { useContext } from "react";
import { appContext } from "../context/AppContext";
import { useQuery } from "@tanstack/react-query";
import { getFeatureToggleConfig } from "../services/getFeatureToggleConfig";

export function useFeatureToggle() {
  const context = useContext(appContext);
  return useQuery({
    queryKey: ["account-feature-toggle"],
    queryFn: async ({ signal }) =>
      getFeatureToggleConfig(context.getAccessToken, signal),
  });
}